import MenubarView from './MenubarView'
import Iframe from 'react-iframe'
import { useEffect, useState} from 'react';


const HomeView = () => {

    const [dashboardUrl,setDashboardUrl] = useState(null)
    const all = "https://amreporting.sevtekin.com/public/dashboard/468a2c17-1820-4e70-8d00-e7b101481218"
    const gundiler = "https://amreporting.sevtekin.com/public/dashboard/563d0d47-e361-4e77-b09e-dc8821a2a848"
    const wh = "https://amreporting.sevtekin.com/public/dashboard/28a9427c-ae1b-4d4a-b6db-683af44b1a10"
    
    
    
   
    useEffect(() => {
        const dataAccess = localStorage.getItem('dataAccess').split(',')
        if (dataAccess)
            if ((dataAccess.includes('7')) && (dataAccess.length<=3))
                setDashboardUrl(gundiler)
            else if ((dataAccess.includes('8')) && (dataAccess.length<=3))
                setDashboardUrl(wh)
            else if (dataAccess.length>=3)
                setDashboardUrl(all)  
            else
                setDashboardUrl('./logo.gif') 
    }, [])

    const mystyle = {
        height: "100%",
        width: "100%",
        position: 'relative',
    
    };
    return (
    
        <div>
            <MenubarView/>  
            <div style={mystyle}> 
                <Iframe url= {dashboardUrl}
                width="100%"
                height="1200"
                position= "relative"
                frameBorder="0"
                />
             </div>
        </div>
    );
}
export default HomeView
